import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Routes } from 'routing';
import CreateDiscountCode from 'views/Products/Discount/CreateDiscountCode/index';
import EditDiscountCode from 'views/Products/Discount/EditDiscount/index';

const DiscountRouter = () => {
	return (
		<Switch>
			<Route exact path={Routes.CATALOG_CREATE_DISCOUNT} component={CreateDiscountCode} />
			<Route path={Routes.CATALOG_DISCOUNT} component={EditDiscountCode} />
			<Redirect to={Routes.CatalogTab('discounts')} />
		</Switch>
	);
};

export default DiscountRouter;
